// extracted by mini-css-extract-plugin
module.exports = {"root":"hand-sanitizer-recycling-page_root__nw7gM"};